import { SESSION_START, SESSION_END } from "../actions/types";

interface userState {
  isLogged: boolean;
  token?: string;
  username?: string;
  roles?: string[];
}

const userState: userState = {
  isLogged: false,
};

export default function userReducer(state = userState, action: any) {
  switch (action.type) {
    case SESSION_START:
      let token: string = action.payload.token;
      let username: string = action.payload.username;
      let roles: string[] = action.payload.roles;
      return {
        token,
        username,
        isLogged: true,
        roles,
      };

    case SESSION_END:
      return {
        isLogged: false,
      };

    default:
      return state;
  }
}
